import { getSession, updateSession } from '../../api/session-api';
import { ISession } from '../../models/pro-sites';
import { IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_SESSION_SUCCESS = 'LOAD_SESSION_SUCCESS';
export const LOAD_SESSION_ERROR = 'LOAD_SESSION_ERROR';
export const UPDATE_SESSION_SUCCESS = 'UPDATE_SESSION_SUCCESS';
export const UPDATE_SESSION_ERROR = 'UPDATE_SESSION_ERROR';

// Actions
export const loadSessionSuccess = (result: IResult<ISession>) => ({
    type: LOAD_SESSION_SUCCESS,
    result,
});

export const loadSessionError = (error: any) => ({
    type: LOAD_SESSION_ERROR,
    result: error,
});

export const updateSessionSuccess = (result: IResult<ISession>) => ({
    type: UPDATE_SESSION_SUCCESS,
    result,
});

export const updateSessionError = (error: any) => ({
    type: UPDATE_SESSION_ERROR,
    result: error,
});

// Thunks
export const loadSession = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('LOAD_SESSION'));
            const result = await getSession();
            dispatch(loadSessionSuccess(result));
        } catch (error) {
            dispatch(loadSessionError(error));
            dispatch(apiCallError(error));
        }
    };
};

export const loadSessionSilent = () => {
    return async (dispatch: any) => {
        try {
            const result = await getSession();
            dispatch(loadSessionSuccess(result));
        } catch (error) {
            dispatch(loadSessionError(error));
            dispatch(apiCallError(error));
        }
    };
};

export const updateLoadSession = (session: ISession) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await updateSession(session);
            if (result.ok) {
                dispatch(updateSessionSuccess(result));
                return result.ok;
            } else {
                dispatch(apiCallError(new Error('Error updating session')));
                dispatch(updateSessionError(result));
                return false;
            }
        } catch (error) {
            dispatch(updateSessionError(error));
            throw error;
        }
    };
};
